// Include libraries
/* eslint-disable no-console */
/* eslint-disable no-undef */

/** Global variables **/
/**
 * Additional data we want to pass to the popup
 */
import {
  floatNumberWithSpaces,
  getCookie,
  numberWithSpaces,
  sendMail,
  setCookie,
  validateRecaptcha,
} from "./tools";


import {
  clearAdditionalFormData,
  getAdditionalFormData,
  setAdditionalFormData,
} from "./globals";
import {
  callPopup,
  errorMessagePopup,
  initPopups,
  successMessagePopup,
} from "./popups";
import { logJSONtagData } from "./utils";
import { TweenMax } from "gsap";

/****/

$(document).ready(() => {
  // Init stuff
  initPopups();
  // logJSONtagData("Slider data", "slider-template-data");

  //
  function bio_calculator() {
    let inputs = $("#form-biometry input");

    if (inputs) {
      let biometry_form = $("#form-biometry");

      biometry_form &&
        biometry_form.on("submit", function (e) {
          e.preventDefault();
          let data = new FormData(e.currentTarget);
          // Добавить тип запроса
          data.append("form_type", "biometry_form");
          setAdditionalFormData(data);
          callPopup();
        });

      let price_month_tag = $(
        "#form-biometry .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(1) > p > span:nth-of-type(1)"
      );
      let price_once_tag = $(
        "#form-biometry .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(2) > p > span:nth-of-type(1)"
      );
      let economy_tag = $(
        "#form-biometry .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(3) > p > span:nth-of-type(1)"
      );

      price_month_tag.text(numberWithSpaces(0));
      price_once_tag.text(numberWithSpaces(0));
      economy_tag.text(numberWithSpaces(0));
      inputs.on("input", function () {
        let count_obj = parseInt(
          $(
            '#form-biometry .single-serviceWorktime__calc__wrapper-form-left > .single-serviceWorktime__calc__wrapper-form-left-input > input[name="count_obj"]'
          ).val()
        );
        let count_staff = parseInt(
          $(
            '#form-biometry .single-serviceWorktime__calc__wrapper-form-left > .single-serviceWorktime__calc__wrapper-form-left-input > input[name="count_staff"]'
          ).val()
        );
        let equipment = $(
          '#form-biometry .single-serviceWorktime__calc__wrapper-form-left > .single-serviceWorktime__calc__wrapper-form-left-label > input[name="equipment"]:checked'
        ).val();
        let sync = $(
          '#form-biometry .single-serviceWorktime__calc__wrapper-form-left > .single-serviceWorktime__calc__wrapper-form-left-label > input[name="sync"]:checked'
        ).val();

        if (count_obj && count_staff) {
          let equipment_rent = 0;
          let equipment_buying = 0;
          if (equipment == "Аренда") {
            equipment_rent = 1;
          } else if (equipment == "Покупка") {
            equipment_buying = 1;
          }

          let sync_1c = 0;
          if (sync == "Синхронизация с 1C") {
            sync_1c = 1;
          }

          let obj_price = 0;
          let staff_price = 0;
          let equipment_price = 0;
          let sync_price = 0;

          if (isNaN(count_obj)) {
            obj_price = 0;
          } else if (count_obj == 1) {
            obj_price = 4000 * count_obj;
          } else if (count_obj <= 3) {
            obj_price = 2500 * count_obj;
          } else if (count_obj < 10) {
            obj_price = 2000 * count_obj;
          } else {
            obj_price = 1500 * count_obj;
          }

          staff_price = Math.ceil(count_staff / 100) * 1000;

          if (equipment_rent) {
            equipment_price = count_obj * 500;
          }

          if (sync_1c) {
            sync_price = 2500;
          }

          let price_month =
            obj_price + staff_price + equipment_price + sync_price;

          let price_once = 6000;
          if (equipment_buying) {
            price_once += count_obj * 6500;
          }

          let economy = count_staff * 1500;

          let price_month_tag = $(
            "#form-biometry .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(1) > p > span:nth-of-type(1)"
          );
          let price_once_tag = $(
            "#form-biometry .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(2) > p > span:nth-of-type(1)"
          );
          let economy_tag = $(
            "#form-biometry .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(3) > p > span:nth-of-type(1)"
          );

          price_month_tag.text(numberWithSpaces(price_month));
          price_once_tag.text(numberWithSpaces(price_once));
          economy_tag.text(numberWithSpaces(economy));
        }
      });
    }
  }
  bio_calculator();

  function wifi_calculator() {
    let inputs = $(".single-serviceWorktime__calc__wrapper-form input");

    if (inputs) {
      let equipment_price_tag = $(
        "#form-wifi .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(1) > p > span:nth-of-type(1)"
      );
      let exploitation_price_tag = $(
        "#form-wifi .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(2) > p > span:nth-of-type(1)"
      );
      let montage_price_tag = $(
        "#form-wifi .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(3) > p > span:nth-of-type(1)"
      );

      equipment_price_tag.text(0);
      exploitation_price_tag.text(0);
      montage_price_tag.text(0);

      inputs.on("input", function () {
        let count_floors = parseInt(
          $(
            '#form-wifi .single-serviceWorktime__calc__wrapper-form-left > .single-serviceWorktime__calc__wrapper-form-left-input > input[name="count_floors"]'
          ).val()
        );
        let count_area = parseInt(
          $(
            '#form-wifi .single-serviceWorktime__calc__wrapper-form-left > .single-serviceWorktime__calc__wrapper-form-left-input > input[name="count_area"]'
          ).val()
        );
        let count_devices = parseInt(
          $(
            '#form-wifi .single-serviceWorktime__calc__wrapper-form-left > .single-serviceWorktime__calc__wrapper-form-left-input > input[name="count_devices"]'
          ).val()
        );
        let count_zones = parseInt(
          $(
            '#form-wifi .single-serviceWorktime__calc__wrapper-form-left > .single-serviceWorktime__calc__wrapper-form-left-input > input[name="count_zones"]'
          ).val()
        );
        if (
          !isNaN(count_floors) &&
          !isNaN(count_area) &&
          !isNaN(count_devices) &&
          !isNaN(count_zones)
        ) {
          let equipment_price =
            Math.max(
              count_floors,
              Math.ceil(count_area / 100),
              Math.ceil(count_devices / 100)
            ) *
              7000 +
            Math.ceil(count_zones / 300) * 12000 +
            8000 +
            5000;

          let exploitation_price = equipment_price * 0.5;

          let montage_price = equipment_price * 0.05;

          let equipment_price_tag = $(
            "#form-wifi .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(1) > p > span:nth-of-type(1)"
          );
          let exploitation_price_tag = $(
            "#form-wifi .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(2) > p > span:nth-of-type(1)"
          );
          let montage_price_tag = $(
            "#form-wifi .single-serviceWorktime__calc__wrapper-form-right-content > .single-serviceWorktime__calc__wrapper-form-right-content-item:nth-of-type(3) > p > span:nth-of-type(1)"
          );

          equipment_price_tag.text(floatNumberWithSpaces(equipment_price));
          exploitation_price_tag.text(
            floatNumberWithSpaces(exploitation_price)
          );
          montage_price_tag.text(floatNumberWithSpaces(montage_price));
        }
      });
    }
  }
  wifi_calculator();

  function loan_calculator() {
    let form = $("#loan-calc");
    let count = $("#loan-calc .single-serviceDebt-calculation_count");
    let submit = $("#loan-calc .single-serviceDebt-calculation_submit");
    let input = $(
      "#loan-calc .single-serviceDebt-calculation__wrapper-form-left-block-input > input"
    );
    let price_tag = $("#loan-calc .debt__price > p");

    price_tag.text("0 руб.");

    count.on("click", function () {
      // Calculate our things
      // Внести изменения в расчет стоимости:
      // Для сумм от 150000 руб - фикс стоимость 22500 руб.
      // Для сумм выше 150000 руб. как и было ранее 15%.

      // сумма до 150 000 рублей - 22 500 рублей (как есть)
      // от 150 000 рублей до 500 000 рублей - 35 000 рублей
      // от 500 000 до 1 000 000 - 40 000 рублей
      // от 1 000 000 до 3 000 000 - 55 000 рублей
      // от 3 000 000 рублей - 65 000 рублей

      let sum = parseInt(input.val());

      if (sum < 150000) {
        sum = 22500;
      } else if (sum >= 150000 && sum < 500000) {
        sum = 35000;
      } else if (sum >= 500000 && sum < 1000000) {
        sum = 40000;
      } else if (sum >= 1000000 && sum < 3000000) {
        sum = 55000;
      } else if (sum >= 3000000) {
        sum = 65000;
      }

      price_tag.text(`${floatNumberWithSpaces(sum)} руб.`);
    });

    // TODO: Implement form listener
    form.on("submit", function (e) {
      e.preventDefault();
      let formElement = e.currentTarget;
      let data = new FormData(formElement);
      // Добавить тип запроса
      data.append("form_type", "loan_calculator");
      setAdditionalFormData(data);
      callPopup();
    });
  }
  loan_calculator();

  function toggleMenu() {
    let button = $("#menu");
    let menu = $(".menu");
    let items = $(".menu__wrapper a");
    function hideMenu() {
      button.children().removeClass("active");
      scrollLock.enablePageScroll();
      TweenMax.to(menu, 0.3, {
        opacity: 0,
        onComplete: () => {
          TweenMax.to(menu, 0, { visibility: "hidden", zIndex: 0 });
        },
      });
    }
    TweenMax.to(menu, 0, { visibility: "hidden", zIndex: 0, opacity: 0 });
    button.on("click", function (e) {
      e.preventDefault();
      if ($(this).children().hasClass("active")) {
        hideMenu();
      } else {
        $(this).children().addClass("active");
        scrollLock.disablePageScroll();
        TweenMax.to(menu, 0, {
          visibility: "visible",
          zIndex: 100,
          onComplete: () => {
            TweenMax.to(menu, 0.3, { opacity: 1 });
          },
        });
      }
    });
    Array.from(items).forEach((element) => {
      $(element).on("click", () => {
        hideMenu();
      });
    });
  }
  toggleMenu();

  function toggleMenuMob() {
    let button = $(".mobMenu");
    let menu = $(".menuMob");
    let scrollableElement = $(".menuMob");
    function hideMenu() {
      button.removeClass("active");
      $("body").css("overflow", "");
      scrollableElement.css("overflow-y", "");
      TweenMax.to(menu, 0.3, {
        opacity: 0,
        onComplete: () => {
          TweenMax.to(menu, 0, { visibility: "hidden", zIndex: 0 });
        },
      });
    }
    TweenMax.to(menu, 0, { visibility: "hidden", zIndex: 0, opacity: 0 });
    button.on("click", function (e) {
      e.preventDefault();
      if ($(this).hasClass("active")) {
        hideMenu();
      } else {
        $(this).addClass("active");
        $("body").css("overflow", "hidden");
        scrollableElement.css("overflow-y", "scroll");
        TweenMax.to(menu, 0, {
          visibility: "visible",
          zIndex: 100,
          onComplete: () => {
            TweenMax.to(menu, 0.3, { opacity: 1 });
          },
        });
      }
    });
  }
  toggleMenuMob();

  function sliderHow() {
    new Swiper(".swiper-container-how", {
      slidesPerView: 1,
      loop: false,
      speed: 1000,
      preloadImages: false,
      grabCursor: true,
      autoHeight: true,
      spaceBetween: 30,
      navigation: {
        nextEl: ".how__wrapper-header-nav-right",
        prevEl: ".how__wrapper-header-nav-left",
      },
      // Disable preloading of all images
      preloadImages: false,
      // Enable lazy loading
      lazy: {
        loadPrevNext: true,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }
  sliderHow();

  function sliderScrollText() {
    new Swiper(".swiper-container-ScrollText", {
      direction: "vertical",
      preloadImages: false,
      slidesPerView: "auto",
      observer: true,
      observeParents: true,
      freeMode: true,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      mousewheel: true,
    });
  }
  sliderScrollText();

  function sliderLinks() {
    new Swiper(".swiper-container-links", {
      slidesPerView: 2,
      slidesPerColumn: 2,
      preloadImages: false,
      loop: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 15,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }
  if ($(window).width() < 769) {
    sliderLinks();
  }

  function sliderTwelveItems() {
    new Swiper(".swiper-container-twelve", {
      slidesPerView: 4,
      loop: false,
      preloadImages: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 25,
      on: {
        slideChangeTransitionStart: function () {
          checkTwelveItemsSlides();
        },
      },
      navigation: {
        nextEl: ".single-servicePhysical__services__wrapper-title-nav-right",
        prevEl: ".single-servicePhysical__services__wrapper-title-nav-left",
      },
      breakpoints: {
        1140: {
          allowTouchMove: true,
          slidesPerView: 3,
        },
        991: {
          allowTouchMove: true,
          slidesPerView: 2,
          pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            dynamicBullets: true,
            clickable: true,
          },
        },
        600: {
          allowTouchMove: true,
          slidesPerView: 1,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }
  sliderTwelveItems();

  function checkTwelveItemsSlides() {
    let slide = $(".swiper-container-twelve .swiper-slide");
    let slideActive = $(".swiper-container-twelve .swiper-slide-active");
    slide.removeClass("swiper-slide-opacity");
    slideActive.addClass("swiper-slide-opacity");
    slideActive.next().addClass("swiper-slide-opacity");
    slideActive.next().next().addClass("swiper-slide-opacity");
    slideActive.next().next().next().addClass("swiper-slide-opacity");
  }
  checkTwelveItemsSlides();

  function sliderAboutClients() {
    new Swiper(".swiper-container-aboutClients", {
      slidesPerView: 4,
      loop: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 20,
      // Disable preloading of all images
      preloadImages: false,
      // Enable lazy loading
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: ".aboutPage__wrapper-clients-header-nav-right",
        prevEl: ".aboutPage__wrapper-clients-header-nav-left",
      },
      on: {
        slideChangeTransitionStart: function () {
          checkAboutClientsSlides();
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        1140: {
          allowTouchMove: true,
          slidesPerView: 3,
        },
        991: {
          allowTouchMove: true,
          slidesPerView: 2,
        },
        600: {
          allowTouchMove: true,
          slidesPerView: 1,
        },
      },
    });
  }
  sliderAboutClients();

  function sliderSingle() {
    new Swiper(".swiper-container-single", {
      slidesPerView: 3,
      loop: false,
      preloadImages: false,
      speed: 1000,
      grabCursor: true,
      allowTouchMove: false,
      spaceBetween: 20,
      pagination: {
        el: ".single__wrapperFull-news .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        990: {
          allowTouchMove: true,
          slidesPerView: 2,
        },
        600: {
          allowTouchMove: true,
          slidesPerView: 1,
        },
      },
    });
  }
  sliderSingle();

  function sliderClients() {
    new Swiper(".swiper-container-clients", {
      slidesPerView: 4,
      preloadImages: false,
      loop: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 20,
      navigation: {
        nextEl: ".clients__wrapper-header-nav-right",
        prevEl: ".clients__wrapper-header-nav-left",
      },
      on: {
        slideChangeTransitionStart: function () {
          checkClientsSlides();
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
        dynamicBullets: true,
      },
      breakpoints: {
        991: {
          slidesPerView: 2,
        },
        600: {
          slidesPerView: 2,
        },
      },
    });
  }
  sliderClients();

  function checkClientsSlides() {
    let slide = $(".swiper-container-clients .swiper-slide");
    let slideActive = $(".swiper-container-clients .swiper-slide-active");
    slide.removeClass("swiper-slide-opacity");
    slideActive.addClass("swiper-slide-opacity");
    slideActive.next().addClass("swiper-slide-opacity");
    slideActive.next().next().addClass("swiper-slide-opacity");
    slideActive.next().next().next().addClass("swiper-slide-opacity");
  }
  checkClientsSlides();

  function sliderBlog() {
    new Swiper(".swiper-container-blog", {
      slidesPerView: 3,
      loop: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 20,
      navigation: {
        nextEl: ".blog__wrapper-header-nav-right",
        prevEl: ".blog__wrapper-header-nav-left",
      },
      // Disable preloading of all images
      preloadImages: false,
      // Enable lazy loading
      lazy: {
        loadPrevNext: true,
      },
      on: {
        slideChangeTransitionStart: function () {
          checkBlogSlides();
        },
      },
      breakpoints: {
        991: {
          slidesPerView: 2,
        },
        750: {
          slidesPerView: 1,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    });
  }
  sliderBlog();

  function checkBlogSlides() {
    let slide = $(".swiper-container-blog .swiper-slide");
    let slideActive = $(".swiper-container-blog .swiper-slide-active");
    slide.removeClass("swiper-slide-opacity");
    slideActive.addClass("swiper-slide-opacity");
    slideActive.next().addClass("swiper-slide-opacity");
    slideActive.next().next().addClass("swiper-slide-opacity");
  }
  checkBlogSlides();

  // Just sets classes to the first screen elements
  // TODO: Uncomment when done with css for slider <16-06-21,16-06-21> //
  function indexNav() {
    let button = $(".index__nav-item");
    let header = $(".header");
    let index = $(".index");
    let nav = $(".nav");
    button.on("click", function () {
      header.removeClass("header__third");
      nav.removeClass("nav__third");
      index.removeClass("index__third");
      button.removeClass("index__nav-item-active");
      $(this).addClass("index__nav-item-active");
    });
    $(button[2]).on("click", function () {
      header.addClass("header__third");
      nav.addClass("nav__third");
      index.addClass("index__third");
    });
    $(button[4]).on("click", function () {
      header.addClass("header__third");
      nav.addClass("nav__third");
      index.addClass("index__third");
    });
  }
  indexNav();

  const stopVideo = () => {
    let container = $(".videoContainer");
    let playButton = $(".videoButton");
    let message = $(".videoMessage");
    let video = $("#presentation");
    if (playButton) {
      playButton.on("click", function () {
        if (video.get(0).paused) {
          container.fadeOut(() => {
            message.hide();
            video.get(0).play();
            video.get(0).controls = true;
          });
        } else {
          video.get(0).pause();
        }
      });
    }
  };
  stopVideo();

  function toggleFooter2Items() {
    let button = $(".footer2__wrapper-col-block-title-arrow");
    button.on("click", function () {
      $(this).toggleClass("footer2__wrapper-col-block-title-arrow-active");
      $(this).parent().next().slideToggle();
    });
    function resizeHandler() {
      if ($(window).width() > 1300) {
        button.parent().next().attr("style", "");
      }
    }
    resizeHandler();
    $(window).resize(resizeHandler);
  }
  toggleFooter2Items();

  function scrollInit() {
    let options = {
      delay: 100,
      origin: "bottom",
      opacity: 0,
      mobile: false,
    };
    // ScrollReveal().reveal(".reveal", options);
  }
  scrollInit();

  function sliderContacts() {
    new Swiper(
      ".swiper-container-contacts1, .swiper-container-contacts2, .swiper-container-contacts3, .swiper-container-contacts4, .swiper-container-contacts5, .swiper-container-contacts6, .swiper-container-contacts7, .swiper-container-contacts8, .swiper-container-contacts9",
      {
        slidesPerView: 2,
        speed: 1000,
        grabCursor: true,
        spaceBetween: 21,
        navigation: {
          nextEl: ".swiper-button-next",
        },
        breakpoints: {
          991: {
            slidesPerView: 2,
          },
          700: {
            slidesPerView: 1.2,
          },
        },
      }
    );
  }
  sliderContacts();

  function toggleContactsSlider1() {
    let button = $(
      ".cContent1 .contacts__wrapper-container-content-block-items-item"
    );
    let container = $(
      ".cContent1 .contacts__wrapper-container-content-block-containers-container"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "contacts__wrapper-container-content-block-items-item-active"
        );
        $(this).addClass(
          "contacts__wrapper-container-content-block-items-item-active"
        );
        container.removeClass(
          "contacts__wrapper-container-content-block-containers-container-active"
        );
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .addClass(
            "contacts__wrapper-container-content-block-containers-container-active"
          );
      });
    }
  }
  toggleContactsSlider1();

  function toggleContactsSlider2() {
    let button = $(
      ".cContent2 .contacts__wrapper-container-content-block-items-item"
    );
    let container = $(
      ".cContent2 .contacts__wrapper-container-content-block-containers-container"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "contacts__wrapper-container-content-block-items-item-active"
        );
        $(this).addClass(
          "contacts__wrapper-container-content-block-items-item-active"
        );
        container.removeClass(
          "contacts__wrapper-container-content-block-containers-container-active"
        );
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .addClass(
            "contacts__wrapper-container-content-block-containers-container-active"
          );
      });
    }
  }
  toggleContactsSlider2();

  function toggleContactsSlider3() {
    let button = $(
      ".cContent3 .contacts__wrapper-container-content-block-items-item"
    );
    let container = $(
      ".cContent3 .contacts__wrapper-container-content-block-containers-container"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "contacts__wrapper-container-content-block-items-item-active"
        );
        $(this).addClass(
          "contacts__wrapper-container-content-block-items-item-active"
        );
        container.removeClass(
          "contacts__wrapper-container-content-block-containers-container-active"
        );
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .addClass(
            "contacts__wrapper-container-content-block-containers-container-active"
          );
      });
    }
  }
  toggleContactsSlider3();

  function sendFormVacancies() {
    let form = $(".vacanciesForm__wrapper-block-form");
    let select = $(".vacanciesForm__wrapper-block-form-input-select");
    let text = $(".role");
    if (form) {
      form.submit(async (e) => {
        e.preventDefault();
        let formElement = e.currentTarget;
        let formData = new FormData(formElement);

        let token = await validateRecaptcha(formElement.querySelector(".captcha-container"))
        if (!token) {
          errorMessagePopup();
          return;
        }
        // add token
        formData.set("token", token);

        sendMail(formData).then((response) => {
          if (response.ok) {
            select.css("borderColor", "rgba(24,24,24,0.4)");
            text.text("Выберите должность");
            return (
              successMessagePopup() /*,
            yaCounter********.reachGoal('****', () => {})*/,
              form.get(0).reset()
            );
          } else {
            errorMessagePopup("Отправка почты не удалась, свяжитесь с нами по телефону")
          }
        }).catch(()=> {
          errorMessagePopup("Отправка почты не удалась, свяжитесь с нами по телефону")
        })
      });
    }
  }
  sendFormVacancies();

  function sendFormContacts() {
    let form = $(".contacts__wrapper-container-aside-block-from");
    let popup = $(".popup");
    if (form) {
      form.on("submit", async (e) => {
        e.preventDefault();
        let formElement = e.currentTarget;

        let formData = new FormData(formElement);

        let token = await validateRecaptcha(formElement.querySelector(".captcha-container"))
        if (!token) {
          errorMessagePopup();
          return;
        }
        // add token
        formData.set("token", token);


        sendMail(formData)
          .then((response) => {
            if (response.ok) {
              popup.removeClass("popup-active");
              return (
                successMessagePopup() /*,
            yaCounter********.reachGoal('****', () => {})*/,
                form.get(0).reset()
              );
            } else {
              popup.removeClass("popup-active");
              return errorMessagePopup("Отправка почты не удалась, свяжитесь с нами по телефону"), form.get(0).reset();
            }
          })
          .catch((e) => {
            popup.removeClass("popup-active");
            return errorMessagePopup(), form.get(0).reset();
          });
      });
    }
  }
  sendFormContacts();

  function successMessage() {
    let container = $(".success");
    container.addClass("success-active");
    setTimeout(() => {
      container.removeClass("success-active");
    }, 2000);
  }

  function smoothScroll() {
    new SmoothScroll('a[href*="#"]', {
      speed: 1500,
      after: () => {
        $("body").css("overflow", "");
      },
      header: "[data-scroll-header]",
      offset: 180,
    });
  }
  function smoothScroll2() {
    new SmoothScroll('a[href*="#"]', {
      speed: 1500,
      after: () => {
        $("body").css("overflow", "");
      },
      header: "[data-scroll-header-note]",
      offset: 158,
    });
  }
  function smoothScroll3() {
    new SmoothScroll('a[href*="#"]', {
      speed: 1500,
      after: () => {
        $("body").css("overflow", "");
      },
      header: "[data-scroll-header-mob]",
      offset: 25,
    });
  }

  // Responsive smooth scroll?
  if ($(window).width() > 1440) {
    smoothScroll();
  } else if ($(window).width() > 1140) {
    smoothScroll2();
  } else {
    smoothScroll3();
  }

  function inputMask() {
    let input = $('input[type="tel"]');
    Array.from(input).forEach((element) => {
      let mask = new Inputmask("+7 (999) 999-99-99");
      mask.mask(element);
    });
  }
  inputMask();

  $('input[type="number"]').on("keydown", (e) => {
    if (e.key.length == 1 && e.key.match(/[^0-9'".]/)) {
      return false;
    }
  });

  function hideByClickEscButton() {
    let popup = $(".popup");
    let popupBg = $(".popup-bg");
    let button = $("#menu, .mobMenu");
    let menu = $(".menu");
    let menuMob = $(".menuMob");
    let popupImage = $(".popupImage__bg");
    $(window).on("keydown", (e) => {
      if (e.keyCode == 27) {
        button.removeClass("active");
        scrollLock.enablePageScroll();
        popupImage.removeClass("popupImage__bg-active");
        popup.removeClass("popup-active");
        popupBg.removeClass("popup-bg-active");
        TweenMax.to(menu, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(menu, 0, { visibility: "hidden", zIndex: 0 });
          },
        });
        TweenMax.to(menuMob, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(menuMob, 0, { visibility: "hidden", zIndex: 0 });
          },
        });
        $("#menu").children().removeClass("active");
      }
    });
  }
  hideByClickEscButton();

  function dynamicAsideData() {
    void (function () {
      const select = document.querySelector(".contacts__wrapper-nav-item");
      const options = [
        ...document.querySelectorAll(".contacts__wrapper-nav-item"),
      ];
      const fax = document.querySelector("#fax");
      // $('#fax').addClass("phoneMoscow");
      $("#fax").attr("phone", "phoneMoscow");
      const hiring = document.querySelector("#hiring");
      const licence = document.querySelector("#licence");
      const tfax1 = document.querySelector("#tfax1");
      const tfax2 = document.querySelector("#tfax2");
      const email = document.querySelector("#email");
      options.forEach(
        (option) =>
          (option.onclick = (e) => {
            $(options).removeClass("contacts__wrapper-nav-item-active");
            $(option).addClass("contacts__wrapper-nav-item-active");
       
            select.dispatchEvent(
              new CustomEvent("change", {
                detail: { value: e.currentTarget.getAttribute("data-city") },
              })
            );
          })
      );
      if (select) {
        select.addEventListener("change", (e) => {
        
          let slug = e.detail.value;
          
          $(".contacts_city").removeClass("active")
          $(".contacts_city[city="+slug+"]").addClass("active")

          // console.log(details);
        });
      }
    })();
  }
  dynamicAsideData();

  function toggleContactsContent() {
    let button = $(".contacts__wrapper-nav-item");
    let container = $(".contacts__wrapper-container-content");
    // $(container[0]).addClass("contacts__wrapper-container-content-active");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        container.removeClass("contacts__wrapper-container-content-active");
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .addClass("contacts__wrapper-container-content-active");
      });
    }
  }
  toggleContactsContent();

  function toggleVacancies() {
    let button = $(".vacancies__wrapper-items-item");
    button.on("click", function () {
      $(this).toggleClass("vacancies__wrapper-items-item-active");
      $(this).children().next().next().slideToggle();
    });
  }
  toggleVacancies();

  function toggleVacanciesRoles() {
    let button = $(".vacanciesForm__wrapper-block-form-input-select");
    let items = $(".vacanciesForm__wrapper-block-form-input-items span");
    let text = $(".role");
    let value = $("#role");
    button.on("click", function () {
      $(this).toggleClass(
        "vacanciesForm__wrapper-block-form-input-select-active"
      );
      $(this).children().next().next().next().slideToggle();
      $(this).css("borderColor", "#358227");
    });
    button.on("mouseleave", function () {
      $(this).removeClass(
        "vacanciesForm__wrapper-block-form-input-select-active"
      );
      $(this).children().next().next().next().slideUp();
    });
    for (let i = 0; i < items.length; i++) {
      $(items[i]).on("click", function () {
        $(this)
          .parent()
          .prev()
          .toggleClass("vacanciesForm__wrapper-block-form-input-select-active");
        text.text($(items[i]).text());
        value.val($(items[i]).text());
      });
    }
  }
  toggleVacanciesRoles();

  function updateUploadTitle() {
    let button = $("#uploadLabel");
    let input = $("#upload");
    input.on("change", () => {
      button.text($(input)[0].files[0].name);
      button.parent().css("borderColor", "#358227");
    });
  }
  updateUploadTitle();

  function toggleAsideClientsLinks() {
    let button = $(".clientsPage__wrapper-aside-container-link");
    button.on("click", function () {
      button.removeClass("clientsPage__wrapper-aside-container-link-active");
      $(this).toggleClass("clientsPage__wrapper-aside-container-link-active");
    });
  }
  toggleAsideClientsLinks();

  function toggleAsideLicensesLinks() {
    let button = $(".docs__wrapper-aside-container-link");
    button.on("click", function () {
      button.removeClass("docs__wrapper-aside-container-link-active");
      $(this).addClass("docs__wrapper-aside-container-link-active");
    });
  }
  toggleAsideLicensesLinks();

  function toggleAsideContactsItems() {
    let button = $(
      ".contacts__wrapper-container-aside-block-title svg, .contacts__wrapper-container-content-block-title svg"
    );
    button.on("click", function () {
      $(this).toggleClass("active");
      $(this).parent().next().slideToggle();
    });
  }
  toggleAsideContactsItems();

  function toggleContactsCity() {
    let button = $(".contacts__wrapper-container-content-block-itemsMob-city");
    button.on("click", function () {
      $(this).next().slideToggle();
      $(this).children().next().toggleClass("active");
    });
  }
  toggleContactsCity();

  function chooseContactsCity() {
    let button = $(
      ".contacts__wrapper-container-content-block-itemsMob-container-item"
    );
    button.on("click", function () {
      $(this).parent().prev().children().text($(this).text());
      $(this).parent().slideToggle();
      $(this).parent().prev().children().next().toggleClass("active");
      button.removeClass(
        "contacts__wrapper-container-content-block-itemsMob-container-item-active"
      );
      $(this).addClass(
        "contacts__wrapper-container-content-block-itemsMob-container-item-active"
      );
    });
  }
  chooseContactsCity();

  function toggleContactsSlider1Mob() {
    let button = $(
      ".cContent1 .contacts__wrapper-container-content-block-itemsMob-container-item"
    );
    let container = $(
      ".cContent1 .contacts__wrapper-container-content-block-containers-container"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "contacts__wrapper-container-content-block-itemsMob-container-item-active"
        );
        $(this).addClass(
          "contacts__wrapper-container-content-block-itemsMob-container-item-active"
        );
        container.removeClass(
          "contacts__wrapper-container-content-block-containers-container-active"
        );
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .addClass(
            "contacts__wrapper-container-content-block-containers-container-active"
          );
      });
    }
  }
  toggleContactsSlider1Mob();

  function toggleContactsSlider2Mob() {
    let button = $(
      ".cContent2 .contacts__wrapper-container-content-block-itemsMob-container-item"
    );
    let container = $(
      ".cContent2 .contacts__wrapper-container-content-block-containers-container"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "contacts__wrapper-container-content-block-itemsMob-container-item-active"
        );
        $(this).addClass(
          "contacts__wrapper-container-content-block-itemsMob-container-item-active"
        );
        container.removeClass(
          "contacts__wrapper-container-content-block-containers-container-active"
        );
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .addClass(
            "contacts__wrapper-container-content-block-containers-container-active"
          );
      });
    }
  }
  toggleContactsSlider2Mob();

  function toggleContactsSlider3Mob() {
    let button = $(
      ".cContent3 .contacts__wrapper-container-content-block-itemsMob-container-item"
    );
    let container = $(
      ".cContent3 .contacts__wrapper-container-content-block-containers-container"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "contacts__wrapper-container-content-block-itemsMob-container-item-active"
        );
        $(this).addClass(
          "contacts__wrapper-container-content-block-itemsMob-container-item-active"
        );
        container.removeClass(
          "contacts__wrapper-container-content-block-containers-container-active"
        );
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .addClass(
            "contacts__wrapper-container-content-block-containers-container-active"
          );
      });
    }
  }
  toggleContactsSlider3Mob();

  function toggleNewsMobAsideItems() {
    let button = $(".news__wrapper-asideMob-current");
    button.on("click", function () {
      $(this).children().next().next().slideToggle();
      $(this).toggleClass("news__wrapper-asideMob-current-active");
    });
    button.on("mouseleave", function () {
      $(this).children().next().next().slideUp();
      $(this).removeClass("news__wrapper-asideMob-current-active");
    });
  }
  toggleNewsMobAsideItems();

  function toggleClientsMobAsideItems() {
    let items = $(".clientsPage__wrapper-asideMob-items p");
    let button = $(".clientsPage__wrapper-asideMob-current");
    let text = $(".clientsPage__wrapper-asideMob-current span");
    button.on("click", function () {
      $(this).children().next().next().slideToggle();
      $(this).toggleClass("clientsPage__wrapper-asideMob-current-active");
    });
    for (let i = 0; i < items.length; i++) {
      $(items[i]).on("click", function () {
        text.text($(items[i]).text());
        items.removeClass("active");
        $(this).addClass("active");
      });
    }
    button.on("mouseleave", function () {
      $(this).children().next().next().slideUp();
      $(this).removeClass("clientsPage__wrapper-asideMob-current-active");
    });
  }
  toggleClientsMobAsideItems();

  function toggleNewsMobAsideCats() {
    let button = $(".news__wrapper-asideCatsMob-current");
    button.on("click", function () {
      $(this).children().next().next().slideToggle();
      $(this).toggleClass("news__wrapper-asideCatsMob-current-active");
    });
    button.on("mouseleave", function () {
      $(this).children().next().next().slideUp();
      $(this).removeClass("news__wrapper-asideCatsMob-current-active");
    });
  }
  toggleNewsMobAsideCats();

  function toggleDocsMobAsideItems() {
    let items = $(".docs__wrapper-asideMob-items a");
    let button = $(".docs__wrapper-asideMob-current");
    let text = $(".docs__wrapper-asideMob-current span");
    button.on("click", function () {
      $(this).children().next().next().slideToggle();
      $(this).toggleClass("docs__wrapper-asideMob-current-active");
    });
    for (let i = 0; i < items.length; i++) {
      $(items[i]).on("click", function () {
        text.text($(items[i]).text());
        items.removeClass("active");
        $(this).addClass("active");
      });
    }
    button.on("mouseleave", function () {
      $(this).children().next().next().slideUp();
      $(this).removeClass("docs__wrapper-asideMob-current-active");
    });
  }
  toggleDocsMobAsideItems();

  function toggleTabletClientsItems() {
    let button = $(".clientsPage__wrapper-asideTablet-link");
    button.on("click", function () {
      button.removeClass("clientsPage__wrapper-asideTablet-link-active");
      $(this).toggleClass("clientsPage__wrapper-asideTablet-link-active");
    });
  }
  toggleTabletClientsItems();

  function toggleClientsContainers() {
    let button = $(".clientsPage__wrapper-asideMob-items p");
    let buttonTablet = $(".clientsPage__wrapper-asideTablet-link span");
    let title = $(".clientsPage__wrapper-content-title");
    let container = $(".clientsPage__wrapper-content-toggle");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        container.hide();
        title.hide();
        $(title[i]).attr("data-id", $(this).attr("data-id")).show();
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .css("display", "flex");
      });
    }
    for (let i = 0; i < Array.from(buttonTablet).length; i++) {
      $(buttonTablet[i]).on("click", function () {
        container.hide();
        title.hide();
        $(title[i]).attr("data-id", $(this).attr("data-id")).show();
        $(container[i])
          .attr("data-id", $(this).attr("data-id"))
          .css("display", "flex");
      });
    }
  }
  toggleClientsContainers();

  // FIXME: make it make more sense, it is very confusing
  function checkAboutClientsSlides() {
    let slide = $(".swiper-container-aboutClients .swiper-slide");
    let slideActive = $(".swiper-container-aboutClients .swiper-slide-active");
    slide.removeClass("swiper-slide-opacity");
    slideActive.addClass("swiper-slide-opacity");
    slideActive.next().addClass("swiper-slide-opacity");
    slideActive.next().next().addClass("swiper-slide-opacity");
    slideActive.next().next().next().addClass("swiper-slide-opacity");
  }
  checkAboutClientsSlides();

  function toggleAboutBlocks() {
    let button = $(".aboutPage__wrapper-cats-items-item");
    let container = $(".aboutPage__wrapper-cats-blocks-container");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass("aboutPage__wrapper-cats-items-item-active");
        $(this).addClass("aboutPage__wrapper-cats-items-item-active");
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "flex",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleAboutBlocks();

  function toggleAboutFormation() {
    let button = $(".aboutPage__wrapper-formation-inner-steps-step");
    let container = $(".aboutPage__wrapper-formation-inner-block-container");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "aboutPage__wrapper-formation-inner-steps-step-active"
        );
        $(this).addClass(
          "aboutPage__wrapper-formation-inner-steps-step-active"
        );
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "block",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleAboutFormation();

  function toggleSinglePhysicalBlocks() {
    let button = $(".single-servicePhysical__cats__wrapper-buttons-button");
    let container = $(".single-servicePhysical__cats__wrapper-blocks-block");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "single-servicePhysical__cats__wrapper-buttons-button-active"
        );
        $(this).addClass(
          "single-servicePhysical__cats__wrapper-buttons-button-active"
        );
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "flex",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleSinglePhysicalBlocks();

  function sliderSSPhysicalPortfolio() {
    new Swiper(".swiper-container-SSPhysicalPortfolio", {
      slidesPerView: 1,
      preloadImages: false,
      loop: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 30,
      navigation: {
        nextEl: ".single-servicePhysical__portfolio__wrapper-header-nav-right",
        prevEl: ".single-servicePhysical__portfolio__wrapper-header-nav-left",
      },
    });
  }
  sliderSSPhysicalPortfolio();

  function toggleFaq() {
    $(".single-servicePhysical__faq").on(
      "click",
      ".single-servicePhysical__faq__wrapper-items-item",
      function () {
        $(this).toggleClass(
          "single-servicePhysical__faq__wrapper-items-item-active"
        );
        $(this).children().next().slideToggle();
      }
    );
  }
  toggleFaq();

  function toggleSingleAllCats() {
    let button = $(".single-serviceSecOff__catsAll__wrapper-buttons-button");
    let container = $(
      ".single-serviceSecOff__catsAll__wrapper-containers-block"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "single-serviceSecOff__catsAll__wrapper-buttons-button-active"
        );
        $(this).addClass(
          "single-serviceSecOff__catsAll__wrapper-buttons-button-active"
        );
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "flex",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleSingleAllCats();

  function toggleSingleSecOffCats() {
    let button = $(".single-serviceSecOff__cats__wrapper-buttons-button");
    let container = $(".single-serviceSecOff__cats__wrapper-containers-block");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "single-serviceSecOff__cats__wrapper-buttons-button-active"
        );
        $(this).addClass(
          "single-serviceSecOff__cats__wrapper-buttons-button-active"
        );
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "block",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleSingleSecOffCats();

  function toggleSinglePerson() {
    let button = $(".single-serviceConcierge__tasks__wrapper-buttons-button");
    let container = $(
      ".single-serviceConcierge__tasks__wrapper-containers-block"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "single-serviceConcierge__tasks__wrapper-buttons-button-active"
        );
        $(this).addClass(
          "single-serviceConcierge__tasks__wrapper-buttons-button-active"
        );
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "block",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleSinglePerson();

  function toggleSingleForms() {
    let button = $(
      ".single-serviceConsole__kits__wrapper-block-item-buttons-button"
    );
    let container = $(".single-serviceConsole__kits__wrapper-block-img");
    let container2 = $(".single-serviceConsole__kits__wrapper-block-info-item");
    let container3 = $(".single-serviceConsole__kits__wrapper-form-block");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "single-serviceConsole__kits__wrapper-block-item-buttons-button-active"
        );
        $(this).addClass(
          "single-serviceConsole__kits__wrapper-block-item-buttons-button-active"
        );
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "block",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
        TweenMax.to(container2, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container2, 0, { display: "none" });
            TweenMax.to(
              $(container2[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "block",
                onComplete: () => {
                  TweenMax.to(
                    $(container2[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
        TweenMax.to(container3, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container3, 0, { display: "none" });
            TweenMax.to(
              $(container3[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "block",
                onComplete: () => {
                  TweenMax.to(
                    $(container3[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleSingleForms();

  function toggleSingleSketch() {
    let button = $(".single-serviceWorktime__how__wrapper-cats-cat");
    let container = $(".single-serviceWorktime__how__wrapper-blocks-block");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "single-serviceWorktime__how__wrapper-cats-cat-active"
        );
        $(this).addClass(
          "single-serviceWorktime__how__wrapper-cats-cat-active"
        );
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "block",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleSingleSketch();

  function toggleSingleCheck() {
    let button = $(".single-serviceSignal__check__wrapper-buttons-button");
    let container = $(
      ".single-serviceSignal__check__wrapper-containers-container"
    );
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "single-serviceSignal__check__wrapper-buttons-button-active"
        );
        $(this).addClass(
          "single-serviceSignal__check__wrapper-buttons-button-active"
        );
        TweenMax.to(container, 0.3, {
          opacity: 0,
          onComplete: () => {
            TweenMax.to(container, 0, { display: "none" });
            TweenMax.to(
              $(container[i]).attr("data-id", $(this).attr("data-id")),
              0,
              {
                display: "block",
                onComplete: () => {
                  TweenMax.to(
                    $(container[i]).attr("data-id", $(this).attr("data-id")),
                    0.3,
                    { opacity: 1 }
                  );
                },
              }
            );
          },
        });
      });
    }
  }
  toggleSingleCheck();

  function sliderDebtExamples() {
    new Swiper(".swiper-container-Debt__examples", {
      slidesPerView: 1,
      loop: false,
      preloadImages: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 30,
      navigation: {
        nextEl: ".single-serviceDebt__examples__wrapper-header-nav-right",
        prevEl: ".single-serviceDebt__examples__wrapper-header-nav-left",
      },
    });
  }
  sliderDebtExamples();

  function sliderReady() {
    new Swiper(".swiper-container-ready", {
      slidesPerView: 3,
      loop: false,
      preloadImages: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 21,
      navigation: {
        nextEl: ".single-serviceIP__ready__wrapper-header-nav-right",
        prevEl: ".single-serviceIP__ready__wrapper-header-nav-left",
      },
      on: {
        slideChangeTransitionStart: function () {
          checkReadySlides();
        },
      },
      breakpoints: {
        991: {
          allowTouchMove: true,
          slidesPerView: 1,
        },
      },
    });
  }
  sliderReady();

  function checkReadySlides() {
    let slide = $(".swiper-container-ready .swiper-slide");
    let slideActive = $(".swiper-container-ready .swiper-slide-active");
    slide.removeClass("swiper-slide-opacity");
    slideActive.addClass("swiper-slide-opacity");
    slideActive.next().addClass("swiper-slide-opacity");
    slideActive.next().next().addClass("swiper-slide-opacity");
  }
  checkReadySlides();

  $(".news__wrapper").on("click", "#load-more-items", function () {
    var targetContainer = $(".news__wrapper-content"),
      url = $("#load-more-items").attr("data-url");
    if (url !== undefined) {
      $.ajax({
        type: "GET",
        url: url,
        dataType: "html",
        success: function (data) {
          //  Удаляем старую навигацию
          $("#load-more-items").remove();

          var elements = $(data).find(".news__wrapper-content-item"), //  Ищем элементы
            pagination = $(data).find("#load-more-items"); //  Ищем навигацию

          targetContainer.append(elements); //  Добавляем посты в конец контейнера
          targetContainer.append(pagination); //  добавляем навигацию следом
        },
      });
    }
  });

  $(".single-servicePhysical__faq").on("click", "#load-faq-items", function () {
    var targetContainer = $(".single-servicePhysical__faq__wrapper-items"),
      url = $("#load-faq-items").attr("data-url");
    if (url !== undefined) {
      $.ajax({
        type: "GET",
        url: url,
        dataType: "html",
        success: function (data) {
          //  Удаляем старую навигацию
          $("#load-faq-items").remove();
          var elements = $(data).find(
              ".single-servicePhysical__faq__wrapper-items-item"
            ), //  Ищем элементы
            pagination = $(data).find("#load-faq-items"); //  Ищем навигацию
          targetContainer.append(elements); //  Добавляем посты в конец контейнера
          targetContainer.append(pagination); //  добавляем навигацию следом
        },
      });
    }
  });

  function sliderPartners() {
    new Swiper(".swiper-containerTehnical__partners", {
      slidesPerView: 2,
      loop: false,
      preloadImages: false,
      speed: 1000,
      grabCursor: true,
      spaceBetween: 20,
      breakpoints: {
        991: {
          allowTouchMove: true,
          slidesPerView: 1,
        },
      },
      on: {
        slideChangeTransitionStart: function () {
          checkPartnersSlides();
        },
      },
      navigation: {
        nextEl: ".single-serviceTehnical__partners__wrapper-header-nav-right",
        prevEl: ".single-serviceTehnical__partners__wrapper-header-nav-left",
      },
    });
  }
  sliderPartners();

  function checkPartnersSlides() {
    let slide = $(".swiper-containerTehnical__partners .swiper-slide");
    let slideActive = $(
      ".swiper-containerTehnical__partners .swiper-slide-active"
    );
    slide.removeClass("swiper-slide-opacity");
    slideActive.addClass("swiper-slide-opacity");
    slideActive.next().addClass("swiper-slide-opacity");
  }
  checkPartnersSlides();

  function onMouseOverMenu() {
    let col1 = $(".col1");
    let triangleBlack1 = $(".triangleBlack");

    let col3 = $(".col3");
    let path3 = $(".col3path");

    let col4 = $(".col4");
    let svg4 = $(".svg4");

    col1.on("mouseenter", function () {
      TweenMax.to(triangleBlack1, 0.3, {
        y: 6,
        opacity: 0,
        onComplete: () => {
          setTimeout(() => {
            TweenMax.to(triangleBlack1, 0, {
              y: -6,
              onComplete: () => {
                TweenMax.to(triangleBlack1, 0.3, { y: 0, opacity: 1 });
              },
            });
          }, 100);
        },
      });
    });
    col1.on("mouseleave", function () {
      TweenMax.to(triangleBlack1, 0, { y: 0, opacity: 1 });
    });

    col3.on("mouseenter", function () {
      TweenMax.to(path3, 0.2, {
        x: -5,
        y: 6,
        onComplete: () => {
          TweenMax.to(path3, 0.2, {
            x: 5,
            onComplete: () => {
              TweenMax.to(path3, 0.2, { x: 0, y: 0, onComplete: () => {} });
            },
          });
        },
      });
    });
    col3.on("mouseleave", function () {
      TweenMax.to(path3, 0.2, { x: 0, y: 0 });
    });

    col4.on("mouseenter", function () {
      TweenMax.to(svg4, 0.4, {
        rotation: 120,
        x: 8,
        y: 15,
        onComplete: () => {
          TweenMax.to(svg4, 0, { rotation: 0, x: 0, y: 0 });
        },
      });
    });
  }
  onMouseOverMenu();

  function toggleMobileItems() {
    let button = $(".menuMob__wrapper-container-item p");
    let child = $(".menuMob__wrapper-container-hidden-item");
    button.on("click", function () {
      $(this).next().slideToggle();
      $(this).parent().toggleClass("menuMob__wrapper-container-item-active");
    });
    child.on("click", function () {
      $(this).children().next().slideToggle();
    });
  }
  toggleMobileItems();

  function toggleBigCats() {
    let button = $(
      ".single-serviceSecOff__catsAll__wrapper-containers-block-item-link svg"
    );
    let container = $(
      ".single-serviceSecOff__catsAll__wrapper-containers-block-item-container"
    );
    button.on("click", function () {
      $(this).parent().next().slideToggle();
    });
    for (let i = 0; i < container.length; i++) {
      if ($(container[i]).children().length == 0) {
        $(container[i]).prev().children().next().remove();
      }
    }
  }
  toggleBigCats();

  function toggleSingleTypes() {
    let button = $(
      ".single-serviceConsole__kits__wrapper-block-item-types-button"
    );
    let input = $(".type");
    for (let i = 0; i < Array.from(button).length; i++) {
      $(button[i]).on("click", function () {
        button.removeClass(
          "single-serviceConsole__kits__wrapper-block-item-types-button-active"
        );
        $(this).addClass(
          "single-serviceConsole__kits__wrapper-block-item-types-button-active"
        );
        input.val($(this).text());
        calc_pult("#pult-calc-1");
        calc_pult("#pult-calc-2");
        calc_pult("#pult-calc-3");
      });
    }
  }
  toggleSingleTypes();

  $(".lightgallery").lightGallery();

  function toggleExampleSliderImg() {
    let button = $(
      ".single-serviceDebt__examples__wrapper-slider-slide-img svg"
    );
    let popupImage = $(".popupImage img");
    let popup = $(".popupImage__bg");
    let close = $(".popupImage__bg__close");

    button.on("click", function () {
      let container = $(this);
      let images = container.attr("data-images").split(" ");
      let thumbnails = container.attr("data-thumbnails").split(" ");

      let sources = images.map((image, index) => {
        return {
          src: image,
          thumb: thumbnails[index],
        };
      });

      $(this).lightGallery({
        dynamic: true,
        // html:true,
        enableTouch: true,
        mobileSrc: true,
        preload: 1,
        zoom: true,
        actualSize: true,
        dynamicEl: sources,
      });
    });
  }
  toggleExampleSliderImg();
});
